import type { QueryClient } from 'react-query';

import type { AccountStatusViewDto } from '@identity/application/dtos';
import type { AccountRequirement } from '@identity/domain/types';
import { accountStatusKey } from '@identity/presentation/constants';

/**
 * Marks a requirement as met in the cached account status, then refreshes it in the background.
 *
 * No write returns the status, so patching the copy the front end already has is what lets the
 * wizard advance immediately, and the invalidation right after lets the server correct it.
 *
 * It stores no step — that is still derived on every render — and it is not optimistic: it runs
 * after the write succeeded, so there is nothing to undo.
 */
export const patchSatisfiedRequirement = (
  queryClient: QueryClient,
  requirement: AccountRequirement,
  userId: string | null,
): void => {
  const key = accountStatusKey(userId);

  queryClient.setQueryData<AccountStatusViewDto | undefined>(key, (previous) =>
    previous ? { ...previous, requirements: { ...previous.requirements, [requirement]: true } } : previous,
  );

  queryClient.invalidateQueries(key);
};
